
import {Component, Vue} from 'vue-property-decorator';
import AppDialog from '@/modules/Popup/components/AppDialog.vue';
import {IApp} from "@/interfaces/app.interface";

@Component({
  components: {
    AppDialog,
  },
})
export default class InstallAppInstructionPopup extends Vue {
  $refs: any;
  currentPopup = { blockName: 'home', dialogName: 'installAppInstruction' };
  dontShowAgain = false;

  async mounted() {
    let dontDisplayStorage = localStorage.getItem(IApp.LocalStorageKeys.DontDisplayInstallBanner);
    if (dontDisplayStorage) {
      this.dontShowAgain = JSON.parse(dontDisplayStorage);
    }
  }

  toggleDontShowAgain() {
    localStorage.setItem(IApp.LocalStorageKeys.DontDisplayInstallBanner, JSON.stringify(this.dontShowAgain));
  }

  async onClose() {
    this.$refs.appDialog.onClose();
  }
}
